import {
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_TYPE,
} from "./actionTypes"

export const changeLayoutWidth = width => ({
  type: CHANGE_LAYOUT_WIDTH,
  payload: width,
})

export const changeSidebarType = (sidebarType, isMobile) => {
  return {
    type: CHANGE_SIDEBAR_TYPE,
    payload: { sidebarType, isMobile },
  }
}
